export const SEND_BATCH_MAIL = "SEND_BATCH_MAIL"
export const BATCH_MAIL_LIST = "BATCH_MAIL_LIST"

export const EMAIL_BATCH_SUCCESS = "EMAIL_BATCH_SUCCESS"
export const EMAIL_BATCH_ERROR = "EMAIL_BATCH_ERROR"

